// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"ffdb6c7d","97":"20de3359","156":"52fae096","264":"ca090cb1","453":"ea601c8d","945":"b1617cba","994":"2a95ba99"}[chunkId] + ".chunk.js";
};